import React from 'react';
import { redirectToHomePage } from 'common/utilities/utils';
import { login } from 'common/utilities/LoginUtils';
import { useHistory } from 'react-router-dom';
import { LOCAL_STORAGE_KEYS, ROUTE_URL } from 'common/constants/SharedConstants';

export const SecondaryHeaderNavLink = props => {
  const { children, pathname, signInLink, loggedIn, setOrderComplete, ...rest } = props;

  const history = useHistory();

  const navigateHandler = () => {
    if (signInLink && !loggedIn) {
      login();
    } else if (pathname === ROUTE_URL?.HOME_PAGE) {
      setOrderComplete && localStorage.setItem(LOCAL_STORAGE_KEYS?.ORDER_COMPLETE, true);
      redirectToHomePage({ history });
    } else {
      history.push({
        pathname,
      });
    }
  };

  return (
    <>
      <div {...rest} onClick={navigateHandler}>
        {children}
      </div>
    </>
  );
};
